import { produce } from "../../../../libs/immer";
export var setPopupIsOpenUseCase = function setPopupIsOpenUseCase(isOpen, setState) {
  setState(produce(function (draft) {
    draft.isOpen = true;
  }));
};